import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineFocusIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M8 2H3a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V4h4a1 1 0 0 0 0-2Zm0 18H4v-4a1 1 0 1 0-2 0v5a1 1 0 0 0 1 1h5a1.0002 1.0002 0 0 0 .7071-1.7071A1.0002 1.0002 0 0 0 8 20ZM21 2h-5a1 1 0 1 0 0 2h4v4a1.0002 1.0002 0 0 0 1.7071.7071A1.0002 1.0002 0 0 0 22 8V3a1.0002 1.0002 0 0 0-1-1Zm0 13a1.0001 1.0001 0 0 0-1 1v4h-4a1.0001 1.0001 0 0 0 0 2h5a1.0001 1.0001 0 0 0 1-1v-5a1.0001 1.0001 0 0 0-1-1Z"/>
  </SvgIcon>
}

export default LineFocusIcon
